const envConfig = {
    REACT_APP_REDIRECT_URL: "https://dev.communityportal.devsuiteltts.com/dashboard/ui_repo",
    REACT_APP_CLIENT_ID: "8ae91ebc-1bf8-48a3-b0a0-926953f078cc",
    REACT_APP_AUTHORITY: "https://login.microsoftonline.com/311b3378-8e8a-4b5e-a33f-e80a3d8ba60a",
    REACT_APP_APIREPO_GATEWAY: "https://dev-apihub-bk-gtway-shm-g8dwacfzebc5eyc8.southindia-01.azurewebsites.net",
    REACT_APP_APIREPO_WRITE: "https://dev-apihub-bk-pro-wr-bhdchtechrggc2dx.southindia-01.azurewebsites.net",
    REACT_APP_APIREPO_READ: "https://dev-apihub-bk-pro-rd-cqe3arefchdugsdy.southindia-01.azurewebsites.net",
    REACT_APP_APIREPO_ADMIN: "https://dev-apihub-bk-admn-hpbqase7eshsaqcg.southindia-01.azurewebsites.net",
    REACT_APP_APIREPO_LOGIN: "https://dev-apihub-bk-sign-lgin-dcaeg9gcd6fjg4ck.southindia-01.azurewebsites.net",
    REACT_APP_UIREPO:"https://dev.appstudioltts.com"
};

export default envConfig;
